import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import {exposeTest} from '../../../../actions/mvt';
import {getValue} from '../../../../utils/abacus';

export function mapStateToProps(state, ownProps) {
    const {abacus} = state;
    const {test} = ownProps;
    const variant = getValue(abacus, test);
    return {variant};
}

export class MvtTestComponent extends Component {
    static propTypes = {
        test: PropTypes.string,
        variant: PropTypes.number,
        exposureMinTop: PropTypes.number,
        report: PropTypes.bool,
        reportOnMount: PropTypes.bool,
        children: PropTypes.node
    };

    static defaultProps = {
        exposureMinTop: 10,
        reportOnMount: false
    };

    componentDidMount() {
        const {reportOnMount, test} = this.props;
        if (reportOnMount && this.allowReport()) {
            this.props.dispatch(exposeTest(test));
        }
    }

    allowReport() {
        const {variant, report} = this.props;
        return report && variant !== -1;
    }

    reportWhenVisible(children) {
        const {test, exposureMinTop} = this.props;

        return (
            <VisibilitySensor
                partialVisibility
                minTopValue={exposureMinTop}
                delayedCall
                onChange={this.onVisibilityChange}
                className={test}
            >
                {children}
            </VisibilitySensor>
        );
    }

    onVisibilityChange = (isVisible) => {
        if (!isVisible) {
            return;
        }

        const {test} = this.props;

        this.props.dispatch(exposeTest(test));
    };

    render() {
        const {test, variant, reportOnMount} = this.props;
        const children = (
            <div className={`${test} ${test}${variant} mvt-container`}>
                {this.props.children}
            </div>
        );

        return this.allowReport() && !reportOnMount
            ? this.reportWhenVisible(children)
            : children;
    }
}

export const MvtTest = connect(mapStateToProps)(MvtTestComponent);
export default MvtTest;
